import { options } from 'global/bankID';
import { BID_AGGREGATOR_BASE_URL } from 'global/environment';
import { postRequest } from 'utils/http';

export async function bankIDSigningAPI(personalNumber, userVisibleData) {
  const signingURL = `${BID_AGGREGATOR_BASE_URL}/bid/sign`;
  return postRequest(signingURL, { personalNumber, userVisibleData: btoa(unescape(encodeURIComponent(userVisibleData))) }, options);
}
